import React, { Component } from 'react';

export default class InventoryNotFound extends Component {

  render() {
    return (
      <div className="card">
        <div className="card-header">
          <span className="not-found-msg"><i className="fa fa-exclamation-triangle mr-05 color-yellow"></i> The inventory item <b>{this.props.id}</b> does not exist </span>
        </div>
      </div>
    )
  } 

}